export default __webpack_public_path__ + "static/media/Pre-Insulated-Pipe.2e6d673d.png";